import { useGetMeQuery } from 'store/services/user/meApi';

export const useIsAdmin = (skip: boolean = false) => {
  const { data: user } = useGetMeQuery(undefined, { skip });

  // SECURITY: Using backend RBAC system
  // Backend validates roles on every API call
  // This is for UI display only - actual security is enforced server-side

  // Check if user has admin role from backend
  const isAdmin = user?.roles?.includes('admin') || false;

  return { isAdmin, user };
};